<template>
  <svg xmlns="http://www.w3.org/2000/svg" id="Camada_2" viewBox="0 0 32.74 32.74">
    <g id="Camada_1-2" data-name="Camada_1">
      <g>
        <path
          d="M19.11,0h-2.74C7.37,0,0,7.37,0,16.37h0c0,9,7.37,16.37,16.37,16.37h16.37s0-19.11,0-19.11c0-7.5-6.13-13.63-13.63-13.63ZM31.04,31.11h-14.81c-5.9,0-11.31-3.53-13.44-9.03C-1.24,11.63,6.49,1.63,16.44,1.63h2.94c6.41,0,11.66,5.25,11.66,11.66v17.82Z" />
        <g>
          <rect x="9.35" y="9.71" width="9.35" height="3.12" rx="1.56" ry="1.56" />
          <rect x="9.35" y="14.81" width="14.03" height="3.12" rx="1.56" ry="1.56" />
          <rect x="9.35" y="19.91" width="14.03" height="3.12" rx="1.56" ry="1.56" />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'HelpIcon'
}
</script>
